import { render, staticRenderFns } from "./PartnerWithdrawScreen.vue?vue&type=template&id=3eb6d6ed&scoped=true&"
import script from "./PartnerWithdrawScreen.vue?vue&type=script&lang=js&"
export * from "./PartnerWithdrawScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb6d6ed",
  null
  
)

export default component.exports